// extracted by mini-css-extract-plugin
export default {"root":"DPHmHZ4T","sizeCompact":"MkA3fVJf","sizeMedium":"cMsetIhr","isFailed":"nt0WgO3B"};